import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";


// !--------------------------- Protected Route ---------------------------
export const ProtectedRoute = ({Component}) => {
const {token} = useSelector(state=>state.auth);
return token ? <Component/> : <Navigate to="/auth/login" />
};
// !--------------------------- Public Route ---------------------------
export const PublicRoute = ({Component}) => {
    const {token} = useSelector(state=>state.auth);
    return token ? <Navigate to="/" /> : <Component />
}